<template>
  <v-container fluid>
    <v-row class="mt-6" >
      <v-col
        v-if="currentStep > 1"
        cols="6" sm="auto" order="2" order-sm="1"
      >
        <v-btn
          color="secondary"
          depressed
          v-on:click="updateParentStep(currentStep - 1)"
        >{{ $t("buttons.previous") }}</v-btn>
      </v-col>
      <v-col
        cols="6" sm="auto" order="3" order-sm="2"
        v-bind:class="{ 'text-right': currentStep > 1 }"
        v-if="currentStep < lastStep"
      >
        <v-btn
          color="primary"
          v-on:click="updateParentStep(currentStep + 1)"
        >{{ $t("buttons.next") }}</v-btn>
      </v-col>

      <v-col cols="12" sm="auto" order="4" order-sm="4">
        <v-btn
          class="btn-break"
          v-on:click="resetAll()"
          :block="$vuetify.breakpoint.xsOnly"
          color="secondary" plain
        >{{ $t("buttons.reset") }}</v-btn>
      </v-col>
      <v-col cols="12" order="5" v-if="currentStep === lastStep">
        <p><small><sup>*</sup> {{ $t("result.note") }}</small></p>
      </v-col>
    </v-row>
  </v-container>

</template>

<script>
import {mapState} from "vuex";

export default {
  name: "StepFooterNavigation",
  props: [
    'currentStep',
    'lastStep'
  ],
  computed: {
    ...mapState({
      ctaUrl: state => state.roiResultData['url']
    })
  },
  methods: {
    updateParentStep: function(toStep) {
      this.$emit('update:nextStep',toStep);
    },
    resetAll: function() {
      // save back locale
      let localBackup = this.$store.getters.lang;

      this.$store.dispatch('resetStore').then(() => {
        // reset initial query params to null object
        this.$store.commit('SET_INITIAL_QUERY_PARAMS', {});
        // set locale again
        this.$store.commit('SET_LANG', localBackup);
        // reload initial data
        this.$store.dispatch('setInitialData');
      });

    }
  }
}
</script>

<style>

.btn-break .v-btn__content {
  width: 100%;
  white-space: normal;
  text-align: center;
}

</style>
